import {useEffect, useState} from "preact/hooks";
import {Tooltip} from "./ToolTip.tsx";
import {IconInfo} from "./svg-icons/IconInfo.tsx";
import {IconChevron} from "./svg-icons/IconChevron.tsx";
import {SortSectionProps} from "../types/travel.ts";

export function SortSection({
                                options,
                                title,
                                section,
                                onSortChange,
                                cssClasses ='',
                                sectionClosable = false,
                                defaultValue,
                                setDefaultValue
                            }: SortSectionProps) {
    const [isSectionOpen, setIsSectionOpen] = useState<SortSectionProps | boolean>(false);
    const [checkedValue, setCheckedValue] = useState<string>('');

    useEffect(() => {
        if(sectionClosable === false) {
            setIsSectionOpen(true)
        }
    }, [sectionClosable]);

    setCheckedValue(defaultValue)

    const handleSortChange = (section: string, value: string) => {
        if(onSortChange) {
            onSortChange({
                section: section,
                value: value
            })
            setCheckedValue(value)
            setDefaultValue(value)
        }
    }

    return (
        <div className={`aside-section ${cssClasses}`}>
            <h3 className={`${isSectionOpen ? '!mb-5' : '!mb-0'}`}>
                {sectionClosable ? (
                    <button
                        onClick={() => setIsSectionOpen(!isSectionOpen)}
                        className={`w-full flex items-center justify-between focus:!text-black/100 hover:!text-black/100`}
                    >
                        <span>{title}</span>
                        <IconChevron cssClasses={`w-[14px] ${isSectionOpen ? 'rotate-180' : 'rotate-0'}`} />
                    </button>
                ) : (<>{title}</>)}
            </h3>

            {isSectionOpen && (
                <div className="space-y-2 lg:space-y-3">
                    {options.length > 0 && (
                        <>
                            {options.map(option => (
                                <div key={option.value}>
                                    <label className="flex items-center cursor-pointer text-12px justify-between">
                                        <span className="inline-flex items-center">

                                            <input type="radio"
                                                   name={`input_${section}`}
                                                   onChange={() => handleSortChange(section, option.value ?? '')}
                                                   checked={checkedValue === option.value}
                                                   className="
                                                        w-4 h-4 mr-2
                                                        rounded-2px border border-theme-black
                                                        accent-theme-primary
                                                        checked:text-white
                                                    "
                                            />
                                            {option.label}
                                            {option.tooltip && (
                                                <Tooltip
                                                    content={option.tooltip}
                                                    cssClasses="top-0.5"
                                                >
                                                    <IconInfo cssClasses="ml-1.5"/>
                                                </Tooltip>
                                            )}
                                        </span>
                                    </label>
                                </div>
                            ))}
                        </>
                    )}
                </div>
            )}
        </div>
    )
}
